export const NOTIFICATIONS_COUNT_NOTIFICATION =
  "notifications.count_notifications";

export const REPORT_GET_VOLANTES_REPORT = "report.get_volantes_report";
export const REPORT_CREATE_VOLANTES_REPORT = "report.create_volantes_report";
export const REPORT_GET_APPOINTMENTS_REPORT = "report.get_appointments_report";
export const REPORT_CREATE_APPOINTMENTS_REPORT =
  "report.create_appointments_report";
export const REPORT_GET_REPORTS = "report.get_reports";
